package com.trevorwiebe.timesheet.core.presentation.common

import androidx.compose.runtime.Composable
import kotlinx.browser.document
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

@Composable
actual fun rememberCsvExporter(): (fileName: String, content: String) -> Unit {
    return { fileName, content ->
        val blob = Blob(arrayOf(content), BlobPropertyBag(type = "text/csv;charset=utf-8"))
        val url = URL.createObjectURL(blob)
        val anchor = (document.createElement("a") as HTMLAnchorElement).apply {
            href = url
            download = fileName
            asDynamic().style.display = "none"
        }
        document.body?.appendChild(anchor)
        anchor.click()
        document.body?.removeChild(anchor)
        URL.revokeObjectURL(url)
    }
}
